import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPerpayPlusContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PerpayPlusContainer" */
                '@perpay-web/fintech/components/containers/PerpayPlusContainer'
            ),
    );
